import { tns } from 'tiny-slider/src/tiny-slider';

(function () {

  if (!document.querySelector('.page-contents')) return this;

  const slider = tns({
    autoplay: true,
    autoplayButtonOutput: false,
    container: '.about-visual',
    nav: false,
    controls: false,
    items: 1,
    mouseDrag: true,
    mode: 'carousel',
    lazyload: true,
    slideBy: 'page',
    autoWidth: true,
    speed: 500,
  });

})();
